import axios from 'axios'

export default class SchedulerServiceClient {
  constructor () {
    this.client = axios.create({
      baseURL: process.env.VUE_APP_SCHEDULING_SERVICE_DOMAIN,
      headers: {
        'x-api-key': process.env.VUE_APP_SCHEDULING_SERVICE_API_KEY
      }
    })
  }

  createAppointmentAndPatient (practiceUuid, data) {
    return this.client.post(`/v2/practices/${practiceUuid}/appointments`, data)
  }
}
